<template>
    <div class="current_attachment">
        <a aria-label="View File" target="_blank" v-bind:href="url">View Attachment #{{ num }}</a>
        <a @click="deleteAttachment($event)" class="text-danger delete_attachment" href="#">Delete</a>
    </div>
</template>

<script>
export default {
    props: ['id', 'mailableId', 'ajax', 'url', 'num'],

    mounted() {
        // console.log('Component mounted.')
    },

    data: function () {
        return {}
    },

    methods: {
        deleteAttachment(event) {
            event.preventDefault();

            let mailableAttachment = this, $this = $(event.target);

            if (!$this.hasClass('disabled')) {

                $this.toggleClass('disabled', true);

                let dialog = bootbox.dialog({
                    title: "Delete Attachment?",
                    message: "This attachment will not be able to be restored.",
                    buttons: {
                        cancel: {
                            label: '<i class="fa fa-times"></i> Cancel',
                            callback: function () {
                                //
                            }
                        },
                        confirm: {
                            label: '<i class="fa fa-check"></i> Confirm',
                            className: 'btn-danger',
                            callback: function () {
                                dialog.find('.modal-footer').remove();

                                dialog.find('.bootbox-body').html('<p><i class="fa fa-spin fa-spinner"></i> Please wait...</p>');

                                axios.post(mailableAttachment.ajax, {
                                    id: mailableAttachment.id,
                                    mailableId: mailableAttachment.mailableId
                                })
                                    .then(response => {
                                        if (response.data.response == 'ok') {

                                            dialog.find('.bootbox-body').html('<p>Attachment Deleted!</p>');

                                            $this.parents('.current_attachment').remove();

                                        } else {

                                            $this.toggleClass('disabled', false);

                                            dialog.find('.bootbox-body').html('<p>Attachment could not be deleted!</p>');
                                        }

                                        setTimeout(function () {
                                            dialog.modal('hide');
                                        }, 500);
                                    })
                                    .catch(errors => {
                                        console.log(errors);

                                        $this.toggleClass('disabled', false);

                                        dialog.find('.bootbox-body').html('<p>Attachment could not be deleted!</p>');

                                        setTimeout(function () {
                                            dialog.modal('hide');
                                        }, 500);
                                    });

                                return false;
                            }
                        }
                    }
                });

            }
        },
    }
}
</script>
